// Áreas da Central da IA no cartão do Hub. A lista vem dos mesmos destinos
// que viravam os botões do cartão (só os módulos liberados na conta, filtrados
// em useHubWorlds); o número de cada área vem do panorama da Central
// (GET ai_center/overview, `modules[aba].pending`). Ligações e Copilot não
// geram itens de revisão e ficam sem número.
//
// A área vem de `aiCenterModule` (o id interno: social, opportunities...),
// não da URL: desde o redesign cada área tem endereço próprio, sem `?tab=`.
// A entrada geral da Central (`any`) não é área e fica de fora.
export const aiCenterTabOf = destination => {
  const id = destination?.aiCenterModule;
  return typeof id === 'string' && id && id !== 'any' ? id : '';
};

export const buildAiCenterModules = (
  destinations = [],
  overviewModules = null
) =>
  (destinations || [])
    .filter(destination => aiCenterTabOf(destination))
    .map(destination => {
      const tab = aiCenterTabOf(destination);
      const raw = overviewModules?.[tab]?.pending;
      const count =
        raw === undefined || raw === null || !Number.isFinite(Number(raw))
          ? null
          : Math.max(0, Number(raw));
      return {
        id: tab,
        destination,
        labelKey: destination.labelKey,
        shortLabelKey: `HUB.CENTRAL.AI_NODES.${tab.toUpperCase()}`,
        count,
      };
    });

// Total do título: a soma do que o cartão mostra, para o número grande e os
// números das áreas nunca discordarem. Nulo enquanto o panorama não chegou.
export const aiCenterPendingTotal = (modules, loaded) => {
  if (!loaded) return null;
  return (modules || []).reduce((sum, item) => sum + (item.count || 0), 0);
};
